interface ToggleSwitchProps {
  checked: boolean
  size?: 'sm' | 'md'
}

export function ToggleSwitch({ checked, size = 'md' }: ToggleSwitchProps) {
  const w = size === 'sm' ? 36 : 44
  const h = size === 'sm' ? 20 : 24
  const knob = size === 'sm' ? 16 : 20
  const pad = 2

  return (
    <div
      role="switch"
      aria-checked={checked}
      style={{
        width: w,
        height: h,
        borderRadius: h / 2,
        background: checked ? 'linear-gradient(135deg, #3B4CCA, #7C5CD3)' : 'var(--line)',
        transition: 'background 0.18s',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: pad,
          left: checked ? w - knob - pad : pad,
          width: knob,
          height: knob,
          borderRadius: '50%',
          background: 'white',
          boxShadow: '0 1px 3px rgba(0,0,0,.22)',
          transition: 'left 0.18s',
        }}
      />
    </div>
  )
}
